import React from 'react';

export default class FeedbackMessage extends React.Component {
    render() {
        return (
            <div className="feedback-message-container d-flex">
                <i className="material-icons">feedback</i>
                <div className="feedback-message">{ this.props.message }</div>
            </div>
        );
    }
}
